import { PropsWithChildren } from "react";

type ComponentProps<T = unknown> = {
  className?: string;
} & T;

export const Heading: React.FC<PropsWithChildren<ComponentProps>> = ({
  className,
  children,
}) => (
  <h5
    className={`${className} leading[1.25] mb-4 font-serif text-[1.125rem] font-bold text-blue900`}
  >
    {children}
  </h5>
);

export const Definition: React.FC<PropsWithChildren<ComponentProps>> = ({
  children,
  className,
}) => (
  <div
    className={`${className} mb-1 flex border-0 border-b-1 border-b-blue600 pb-0.5 text-[0.875rem]`}
  >
    {children}
  </div>
);

export const Term: React.FC<PropsWithChildren> = ({ children }) => (
  <dt className="w-[25%] pr-4 font-bold text-blue900">{children}</dt>
);

export const Descr: React.FC<PropsWithChildren> = ({ children }) => (
  <dd className="w-[75%]">{children}</dd>
);

export const Table: React.FC<ComponentProps<{ data?: string[][] }>> = ({
  data,
  className,
}) => {
  if (!data || data.length === 0) return null;

  const headers = data[0];
  const rows = data.slice(1);

  return (
    <div className={`${className} w-full overflow-x-scroll`}>
      <table
        className="w-full leading-[1.3]"
        aria-label="Sizing Chart"
        cellSpacing="0"
      >
        <thead>
          <tr>
            {headers.map((header, i) =>
              i > 0 ? (
                <th
                  className={`px-2 py-1 text-center font-bold md:px-2 md:py-0.5 ${i % 2 === 1 ? "bg-[#f4f4f5] md:bg-[transparent]" : ""}`}
                  key={`sizing-chart-header-${i}`}
                >
                  {header}
                </th>
              ) : (
                <th
                  key={`sizing-chart-header-${i}`}
                  className="sr-only"
                >
                  Part of Clothing
                </th>
              ),
            )}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={`sizing-chart-tr-${i}`}>
              {row.map((cell, j) => (
                <td
                  className={`px-2 py-1 ${j === 0 ? "text-left" : "text-center"}  ${j % 2 === 1 ? "bg-[#f4f4f5] md:bg-[transparent]" : ""} whitespace-nowrap`}
                  key={`sizing-chart-td-${i}-${j}`}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
